import React from "react";
import PropTypes from "prop-types";

const Loader = (props) => {
	const containerClassName = "c-reactloader dark status " + (props.size ? "o-col-" + props.size : "o-col-12");
	const text = props.text ? <h5>{props.text}</h5> : null;

	const scrollYSize = window.parent.scrollY;
	let top = 0;
	const loaderHeight = 40;
	const headerHeight = 314;

	if (window.innerHeight === window.parent.innerHeight) {
		// lokaal
		top = ((window.innerHeight + loaderHeight) / 2);
	}
	else {
		const x = headerHeight - scrollYSize + (loaderHeight / 2);
		top = window.parent.innerHeight / 2 - x;
		top = top > (window.innerHeight - loaderHeight * 2) ? window.innerHeight - loaderHeight * 2 : top;
		top = top < (loaderHeight) ? (loaderHeight) : top;
	}

	return (
		<div className={containerClassName} style={{ position: 'absolute', top: top }}>
			<i className="loader">
			</i>
			{text}
		</div>
	);
};

Loader.propTypes = {
	size: PropTypes.number,
	text: PropTypes.string
};

export default Loader;
